/* --------------- swiper --------------- */
window.addEventListener('DOMContentLoaded', function() {
  const recommendSwiper = new Swiper('.swiper', {
    loop: true,
      loopAdditionalSlides: 1,
      speed: 500,
      centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      slidesPerView: 3,
      spaceBetween: 24,
      breakpoints: {
          // when window width is >= 749px
          749: {
              slidesPerView: 5, 
              spaceBetween: 36,
          }
      }
  });
});


/* --------------- modal --------------- */
window.addEventListener('DOMContentLoaded', function() {
  function modalOpen(e) {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var target = e.currentTarget.dataset.target;
      var modal = document.getElementById(target);
      var cover = document.querySelector('.modal-cover');
      modal.classList.toggle('is-open');
      modal.classList.toggle('is-close');
      cover.classList.toggle('is-open');
      cover.classList.toggle('is-close');
      document.querySelector('body').dataset.top = scrollTop;
      document.querySelector('body').classList.add('is-fixed');
      document.querySelector('body').style.top = -scrollTop + "px";
  }
    
  function modalClose() {
      var scrollPos = document.querySelector('body').dataset.top;
      for (var i = 0; i < document.querySelectorAll('.js-modal').length; i++) {
        if (document.querySelectorAll('.js-modal')[i].classList.contains("is-open")) {
          document.querySelectorAll('.js-modal')[i].classList.add('is-close');
        }
        document.querySelectorAll('.js-modal')[i].classList.remove('is-open');
      	document.querySelector('.modal-cover').classList.remove('is-open');
      	document.querySelector('.modal-cover').classList.add('is-close');
        document.querySelector('body').classList.remove('is-fixed');
        document.querySelector('body').style.top = "";
        window.scrollTo(0, scrollPos)
      }
  }
    
  function modalEvent() {
      var openBtn = document.querySelectorAll('.js-modal-open');
      Array.prototype.forEach.call(openBtn, function (modalOpenElement) {
        modalOpenElement.addEventListener('click', modalOpen);
      });
      var closeBtn = document.querySelectorAll('.js-modal-close');
      Array.prototype.forEach.call(closeBtn, function (modalCloseElement) {
        modalCloseElement.addEventListener('click', modalClose);
      });
  }
  modalEvent();
});